// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YKPOZXU7UIEq44L7 {
    position: absolute;
    top: 5px;
    right: -13px;
    background-color: var(--lok-color-background-action-danger-default);
    font-size: 8px;
    color: var(--lok-color-text-inverse);
    border-radius: var(--lok-radius-rounded);
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
}

.kuzuWhpmA8UyBAl5 {
    background-color: var(--lok-color-background-active);
    border: none;
    color: var(--lok-color-background-action-primary-pressed);
}

.u1aT_9Sf7_UIEKUy {
    cursor: pointer;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: var(--lok-color-background-action-primary-default);
    background-color: transparent;
    padding: 0;
    border: none;
}

.u1aT_9Sf7_UIEKUy:hover,
.u1aT_9Sf7_UIEKUy:focus {
    color: var(--lok-color-background-action-primary-hover);
}

.u1aT_9Sf7_UIEKUy:active,
.u1aT_9Sf7_UIEKUy:active:hover {
    color: var(--lok-color-background-action-primary-pressed);
}

.hMelFs9kacsf0QPK {
    color: inherit !important;
    display: block;
    position: relative;
    padding-top: var(--lok-spacing-2);
    padding-bottom: 14px;
    background-color: transparent !important;
}

.hMelFs9kacsf0QPK[disabled] {
    pointer-events: none;
}

.hMelFs9kacsf0QPK.EZIYT2sfmgD2M1Sw {
    color: var(--lok-color-text-disabled) !important;
}

.agwKSMpZOuU36HIf {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.VhGeIp1o07UmuXzJ {
    opacity: 0.6;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/features/project/components/ProjectNavigationPanel/components/ProjectNavigation/ProjectNavigationItem/styles.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,mEAAmE;IACnE,cAAc;IACd,oCAAoC;IACpC,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;IACpD,YAAY;IACZ,yDAAyD;AAC7D;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,yDAAyD;IACzD,6BAA6B;IAC7B,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,uDAAuD;AAC3D;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;IAEI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;IACjC,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":[".badge {\n    position: absolute;\n    top: 5px;\n    right: -13px;\n    background-color: var(--lok-color-background-action-danger-default);\n    font-size: 8px;\n    color: var(--lok-color-text-inverse);\n    border-radius: var(--lok-radius-rounded);\n    width: 12px;\n    height: 12px;\n    line-height: 12px;\n    text-align: center;\n}\n\n.tag {\n    background-color: var(--lok-color-background-active);\n    border: none;\n    color: var(--lok-color-background-action-primary-pressed);\n}\n\n.withLinkStyle {\n    cursor: pointer;\n    font-size: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    color: var(--lok-color-background-action-primary-default);\n    background-color: transparent;\n    padding: 0;\n    border: none;\n}\n\n.withLinkStyle:hover,\n.withLinkStyle:focus {\n    color: var(--lok-color-background-action-primary-hover);\n}\n\n.withLinkStyle:active,\n.withLinkStyle:active:hover {\n    color: var(--lok-color-background-action-primary-pressed);\n}\n\n.withNavLinkStyle {\n    composes: withLinkStyle;\n    color: inherit !important;\n    display: block;\n    position: relative;\n    padding-top: var(--lok-spacing-2);\n    padding-bottom: 14px;\n    background-color: transparent !important;\n}\n\n.withNavLinkStyle[disabled] {\n    pointer-events: none;\n}\n\n.withNavLinkStyle.disabled {\n    color: var(--lok-color-text-disabled) !important;\n}\n\n.projectNavigationItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.projectNavigationItemDisabled {\n    opacity: 0.6;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `YKPOZXU7UIEq44L7`,
	"tag": `kuzuWhpmA8UyBAl5`,
	"withLinkStyle": `u1aT_9Sf7_UIEKUy`,
	"withNavLinkStyle": `hMelFs9kacsf0QPK u1aT_9Sf7_UIEKUy`,
	"disabled": `EZIYT2sfmgD2M1Sw`,
	"projectNavigationItem": `agwKSMpZOuU36HIf`,
	"projectNavigationItemDisabled": `VhGeIp1o07UmuXzJ`
};
export default ___CSS_LOADER_EXPORT___;
